<template>
  <div>
    <div class="not_supported_holder">
      <h4>This page is not supported for this resolution</h4>
    </div>
    <div class="scoolio_certificate_builder">
      <!-- certifcate details info -->
      <vs-card class="cstm_vx_card">
        <div slot="header" class="flex flex-wrap justify-between">
          <div>
            <h4>Certificate Builder</h4>
            <p v-if="editTrue">(Edit certificate here)</p>
            <p v-else>(Create certificate here)</p>
          </div>
          <div class="text-right">
            <vs-row>
                <!-- <h6 class="m-1">Course Specific</h6> -->
               <v-select 
              style="min-width: 200px;"
              placeholder="Select Course Type"
            appendToBody
            v-model="typeSpecific"
            :options="certificateType" 
            :reduce="option => option.id"
            label="value"
            name="value"
            :clearable="false"
             @input="fetchDynamicField()"
          ></v-select>
            </vs-row>
          </div>
        </div>
        <div>
          <form data-vv-scope="certificate_field">
          <vs-input
            type="text"
            v-validate="'required'"
            v-model="Certificate_title"
            class="w-full mb-4"
            placeholder="Title"
            data-vv-name="Certificate Title"
          />
          <span v-show="errors.has('certificate_field.Certificate Title')" class="text-danger">{{errors.first('certificate_field.Certificate Title')}}</span>
          <vs-textarea data-vv-name="Certificate Description" label="Description" v-model="certificate_description" />
          </form>
          <!-- <vs-checkbox v-model="courseSpecific">Course Specific</vs-checkbox> -->
        </div>
      </vs-card>
      <!-- end of certifcate details info -->

      <!-- steps for certificate upload -->
      <div class="scoolio_wizard_holder">
        <form-wizard
          class="cstm_form_wizard certificate_form_wizard"
          :title="null"
          :subtitle="null"
          color="rgba(var(--vs-primary), 1)"
        >
          <tab-content title="Choose Image" :before-change="fieldValidation" icon="feather icon-image">     
            <div class="relative">
              <div v-if="editTrue">
                <template v-for="(eachimage, index) in certificateImage">
                <span class="selected_image_holder" v-if="chooseImage.file.files_id == eachimage.file.files_id" :key="index">
                  <p style="color: #000; font-size: 16px; font-weight: 600;">Selected Image</p>
                  <img style="width: 100px; height: 80px; object-fit: contain;" :src="eachimage.file.file_path" alt="">
                </span>
              </template>
              </div>
            

              <file-upload
                class="file-upload"
                section_type="CertificateComponent"
                :file_repository_id="repository_id"
                @image="addImage"
                @getFileId="getFileId"
                @deletedIndex="deletedIndex"
                :edit="editTrue"
              >
              </file-upload>
            </div>
            <h6 class="mt-5 text-center or_holder">
              <span>OR</span>
            </h6>
            <div class="carousel-example">
              <h4 class="text-center mt-5">Choose from the list</h4>
              <swiper
                v-if="editTrue"
                :options="swiperOption"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :key="$vs.rtl"
              >
                <swiper-slide
                  v-for="(eachimage, index) in certificateImage"
                  :key="index"
                >
                  <vs-radio
                    :class="{
                      active:
                        chooseImage.file.files_id == eachimage.file.files_id
                          ? true
                          : false,
                    }"
                    v-model="chooseImage"
                    name="radio1"
                    :vs-value="eachimage"
                  >
                    <img
                      class="responsive"
                      :src="eachimage.file.file_path"
                      alt="banner"
                    />
                    <label
                      style="font-weight: 500"
                      class="block text-center my-2"
                      >{{ eachimage.name }}</label
                    >
                  </vs-radio>
                </swiper-slide>

                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
              <swiper
                v-else
                :options="swiperOption"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :key="$vs.rtl"
              >
                <swiper-slide
                  class="position-relative"
                  v-for="(eachimage, index) in certificateImage"
                  :key="index"
                >
                  <vs-radio
                    v-model="chooseImage"
                    name="radio1"
                    :vs-value="eachimage"
                  >
                    <img
                      class="responsive"
                      :src="eachimage.file.file_path"
                      alt="banner"
                    />
                    <label
                      style="font-weight: 500"
                      class="block text-center my-2"
                      >{{ eachimage.name }}</label
                    >
                    <div
                      class="delTemImg_holder"
                      @click="delTempImg(eachimage.certificate_image_id)"
                    >
                      <span class="material-icons-outlined">close</span>
                    </div>
                  </vs-radio>
                </swiper-slide>

                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </div>
          </tab-content>

          <tab-content title="Customize Certificate" icon="feather icon-edit">
            <div
              class="bg-white cstm-card"
              style="box-shadow: 0 4px 25px rgba(0, 0, 0, 0.1)"
            >              
              <div class="h-full p-4">
                <h5>Select Dynamic Field</h5>
                <div class="field_holder my-4 mb-0">
                  <div
                    class="outer-field-cstm-badge z-10 inline-block my-1 mx-2"
                    v-for="field in dynamic_field"
                    :key="field.field_id"
                  >
                    <div class="field-cstm-badge m-0">
                      <a @click="appendCodeToTemplate(field.field_code)">{{
                        field.field_name
                      }}</a>
                      <a class="info"
                        ><span class="material-icons">info</span></a
                      >
                      <p class="description">{{ field.field_description }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="certificate_editor_holder">
              <content-component :file_repository_id="repository_id" v-model="content"> </content-component>
              <div
                v-if="chooseImage"
                v-html="content"
                class="preview_component"
                :style="{
                  backgroundImage: 'url(' + chooseImage.file.file_path + ')',
                }"
              ></div>
            </div>
          </tab-content>

          <tab-content title="Actions" icon="feather icon-settings">
            <div
              v-if="chooseImage"
              v-html="content"
              class="text-center previewed_action_holder"
              :style="{
                backgroundImage: 'url(' + chooseImage.file.file_path + ')',
              }"
            ></div>
          </tab-content>        
        
      
          <template slot="footer" scope="props">
            <div class="wizard-footer-left" v-if="props.activeTabIndex > 0 && !props.isLastStep">
              <vs-button type="border" @click.native="props.prevTab()">Back</vs-button>
            </div>
            <div class="wizard-footer-right" :class="chooseImage==null? 'overlay_btn':''" v-if="props.activeTabIndex == 0">
              <vs-button  @click.native="props.nextTab()">Save & Next</vs-button>
          </div>
            <div class="wizard-footer-right"  v-if="props.activeTabIndex == 1">
              <vs-button v-if="content==''" @click="contentCheck">Save & Next</vs-button>
              <vs-button v-else @click.native="props.nextTab()">Save & Next</vs-button>
            </div>
            <div class="finish_slot" v-if="props.isLastStep">
              <div>
                <vs-button type="border" @click.native="props.prevTab()"
                  >Back</vs-button
                >
              </div>
              <div class="bulk_holder">
                <a @click="saveCerificate">
                  Save
                </a>
                <a v-if="typeSpecific==0 && editTrue==false && checkCertificateGeneratePermission()" @click="generateCertificatePopup = true">
                  Generate & Save
                </a>
                <!-- <vs-button icon="download">Image</vs-button>
                <vs-button icon="download">PDF</vs-button>
                <vs-button>Save</vs-button>
                <vs-button v-if="courseSpecific" @click="generateCertificatePopup = true">Save & Generate</vs-button> -->
              </div>
            </div>
          </template>
        </form-wizard>
      </div>
      <vs-popup
        class="holamundo"
        title="Generate Certificate"
        :active.sync="generateCertificatePopup"
      >
        <!-- shared with staffs name -->
        <span v-if="selectedStaffs.length != 0">
          <h6 class="mb-4">Shared Staffs :</h6>
          <div class="flex flex-wrap mb-4">
            <div
              class="text-center mr-1"
              v-for="(selectedUser, index1) in selectedStaffs"
              :key="index1"
            >
              <div class="selected-names">
                <!-- <p>{{selectedUser.first_name[0]}} {{selectedUser.last_name[0]}}</p> -->
                <img
                    v-if="selectedUser.picture"
                    class="person-img rounded-full"
                    :src="selectedUser.picture"
                  />
              <img
              v-else
                class="person-img rounded-full shadow-md block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
                <span @click="closeSelectedUser1(index1)" class="close"
                  >&times;</span
                >
              </div>
              <p class="name-selected">
                {{ selectedUser.first_name }} {{ selectedUser.last_name }}
              </p>
            </div>
          </div>
          <vs-divider />
        </span>

        <!-- shared with students name -->

        <span v-if="selectedStudents.length != 0">
          <h6 class="mb-4">Shared Students :</h6>
          <div class="flex flex-wrap mb-4">
            <div
              class="text-center mr-1"
              v-for="(selectedUser, index2) in selectedStudents"
              :key="index2"
            >
              <div class="selected-names">
                <!-- <p>{{selectedUser.first_name[0]}} {{selectedUser.last_name[0]}}</p> -->
                 <img
                    v-if="selectedUser.picture"
                    class="person-img rounded-full"
                    :src="selectedUser.picture"
                  />
              <img
              v-else
                class="person-img rounded-full shadow-md block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
                <span @click="closeSelectedUser2(index2)" class="close"
                  >&times;</span
                >
              </div>
              <p class="name-selected">
                {{ selectedUser.first_name }} {{ selectedUser.last_name }}
              </p>
            </div>
          </div>
          <vs-divider />
        </span>

        <vs-tabs class="cstm_line_tabular_view">
          <vs-tab label="Staffs">
             <div class="tab-text">
            <vs-input 
              class="ml-auto mb-4" 
              icon-pack="feather" 
              icon="icon-search" 
              icon-before 
              placeholder="Search" 
              type="text" 
              @input="fetchStaffBySearch" 
              v-model="searchName"
            >Search</vs-input>

            <div class="person-list-holder">
            <vs-table
              class="checkbox_removed_vstable cstm_vuexy_table"
              multiple
              v-model="selectedStaffs"
              :data="userList"
            >
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td style="width: 40px" :data="data[indextr].picture">
                    <img
                      v-if="data[indextr].picture != ''"
                      class="person-img rounded-full shadow-md block"
                      :src="data[indextr].picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full shadow-md block"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                  </vs-td>
                  <vs-td>
                    <span>
                      {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                    </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            </div>
             </div>
            <div class="flex flex-wrap justify-between items-center my-4">
              <div>
                <vs-button
                  v-if="currentPageUser > 1"
                  @click="showBackUser"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-chevron-left"
                ></vs-button>
              </div>
              <div class="text-right">
                <vs-button
                  icon-pack="feather"
                  icon="icon-chevron-right"
                  v-if="showButtonUser == true"
                  @click="showMoreUser"
                  ></vs-button
                >
              </div>
            </div>
          </vs-tab>

          <vs-tab label="Students">
             <div class="tab-text">
            <vs-input 
              class="ml-auto mb-4" 
              icon-pack="feather" 
              icon="icon-search" 
              icon-before 
              placeholder="Search" 
              type="text" 
              @input="fetchStudentBySearch" 
              v-model="searchName"
            >Search</vs-input>

            <div class="person-list-holder">
            <vs-table class="checkbox_removed_vstable cstm_vuexy_table" multiple v-model="selectedStudents" :data="clientList">
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td style="width: 40px" :data="data[indextr].picture">
                    <img
                      v-if="data[indextr].picture != ''"
                      class="person-img rounded-full shadow-md block"
                      :src="data[indextr].picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full shadow-md block"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                  </vs-td>
                  <vs-td>
                    <span>
                      {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                    </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            </div>
             </div>
            <div class="flex flex-wrap justify-between items-center my-4">
              <div>
                <vs-button
                  v-if="currentPageClient > 1"
                  @click="showBackClient"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-chevron-left"
                ></vs-button>
              </div>
              <div class="text-right">
                <vs-button
                  icon-pack="feather"
                  icon="icon-chevron-right"
                  v-if="showButtonClient == true"
                  @click="showMoreClient"
                  ></vs-button
                >
              </div>              
            </div>
          </vs-tab>
          <div class="text-right mt-4">
            <vs-button class="block ml-auto mt-4" v-if="checkCertificateGeneratePermission()" @click="saveAndGenerate">Generate & Save</vs-button>
            </div>
        </vs-tabs>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { blog } from '../post-blogs/mixins/blog'
import FileUpload from './certificate_fileupload'
import { repository } from '@/mixins/repository.js'
import {
  dynamicFieldApi,
  saveCerificateApi,
  updateTemplateCerificateApi,
  fetchbackgroundimgApi,
  fetchRepoIdByCustomer,
  saveGenerateApi,
  deleteImg
} from '@/api/certificate'
import ContentComponent from '@/components/tinyEditor/CertificateContent.vue'
import { fetchUserClient } from '@/api/task-project.js'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name:'Certificate',
  mixins: [repository, blog, PermissionMiddleware],
  watch: {
    generateCertificatePopup (new_val) {
      if (!new_val) {
        this.searchName = ''
      }
    }
  },
  data () {
    return {
      query_page: {
        page: 1
      },
      query_page1: {
        page: 1
      },
      searchName:'',
      notSharedclient:[],
      notShareduserList:[],
      certificateType:[
        {
          id:0,
          value:'General'
        },
        {
          id:1,
          value:'Course Specific'
        },
        {
          id:2,
          value:'Class Specific'
        }
      ],
     
      typeSpecific:0,
      repository_id: null,
      Certificate_title: '',
      certificate_description: '',
      content: '',
      chooseImage: null,
      demoActive: false,
      generateCertificatePopup: false,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        // autoplay: {
        //   delay: 2500,
        //   disableOnInteraction: false
        // },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      certificateImage: [],
      selectedStaffs: [],
      dynamic_field: [],
      customer_id: this.$store.getters.customerId,
      selectedStudents: [],
      editTrue: false,
      msg: '',
      delete_temp_id: null,
      result:false,
      dynamic_specific:''
    }
  },
  components: {
    ContentComponent,
    FormWizard,
    TabContent,
    swiper,
    swiperSlide,
    FileUpload,
    VueHtml2pdf,
    vSelect  },
  async created () {
    await this.fetchRepo()
    await this.fetchDynamicField()
    
    await this.checkPermissionForCertificate()
    await this.fetchUser()
    await this.fetchClient()
    await this.fetchbackgroundimg()
    if (this.$route.params.editing_object) {
      this.editTrue = true
      this.Certificate_title = this.$route.params.editing_object.title
      this.certificate_description =
        this.$route.params.editing_object.description
      this.content = this.$route.params.editing_object.content
      this.typeSpecific =
        this.$route.params.editing_object.type
      this.chooseImage =
        this.$route.params.editing_object.certificate_image_details
    }
  },
  methods: {
    fetchStaffBySearch () {
      this.searchStaff(this)
    },
    fetchStudentBySearch () {
      this.searchStudent(this)
    },
    searchStaff: _.debounce(async (vm) => {
      try {
        const payload = {
          name: vm.searchName,
          source: true
        }
        
        const res = await fetchUserClient(
          'User', 
          localStorage.getItem('customer_id'),
          vm.query_page,
          payload
        )
        vm.userList = res.data.data.users_list
      
        vm.showButtonUser = res.data.data.meta.has_next
      } catch (e) {
        console.log(e)
      }
    }, 350),
    searchStudent: _.debounce(async (vm) => {
      try {
        console.log(vm.searchName)
        const payload = {
          name: vm.searchName,
          source: true
        }
        
        const res = await fetchUserClient(
          'Client', 
          localStorage.getItem('customer_id'),
          vm.query_page1,
          payload
        )
        vm.clientList = res.data.data.users_list
        vm.showButtonUser = res.data.data.meta.has_next
      } catch (e) {
        console.log(e)
      }
    }, 350),
    contentCheck () {
      this.$vs.notify({
        title: 'Warning',
        text: 'Content is Empty',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning',
        time: 3000
      })
    },
    async fieldValidation () {
      this.result = await this.$validator.validateAll('certificate_field')
      if (!this.result) {
        this.$vs.notify({
          title: 'Warning',
          text: 'All fields are required',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
        return false
      } else {
        return true
      }
    },
    checkPermissionForCertificate () {
      const role_permission = parseInt(localStorage.getItem('role_permission'))
      if (role_permission === 1) {
        this.schoolAdmin = true
      } else {
        this.schoolAdmin = false
        this.getModulePermission('Certificates')
      }
    },
    async delTempImg (id) {
      this.delete_temp_id = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete this record ?',
        accept: this.acceptAlertTemp
      })
    },
    acceptAlertTemp () {
      this.deletingImg()
    },
    async deletingImg () {
      const customer_id = this.$store.getters.customerId

      try {
        await deleteImg(customer_id, this.delete_temp_id)
        this.fetchbackgroundimg()
        this.$vs.notify({
          title: 'Success',
          text: 'Deleted Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (error) {}
    },
    async addImage () {
      this.fetchbackgroundimg()
    },
    onProgress (event) {
      this.percentage = event
      this.showPercentage = true

      if (event === 100) {
        this.showPercentage = false
      }
      //   if(event===100)
    },
    async saveAndGenerate () {
      try {
        const clientNuser = []

        if (this.selectedStudents.length > 0) {
          this.selectedStudents = this.selectedStudents.map((ele) => {
            const container = {}
            container.to_user_type = 2
            container.to_user_id = ele.client_users_id
            return container
          })
          clientNuser.push(this.selectedStudents)
        }
        if (this.selectedStaffs.length > 0) {
          this.selectedStaffs = this.selectedStaffs.map((ele) => {
            const container1 = {}
            container1.to_user_type = 1
            container1.to_user_id = ele.id
            return container1
          })
          clientNuser.push(this.selectedStaffs)
        }
        const payload = {
          title: this.Certificate_title,
          description: this.certificate_description,
          content: this.content,
          type: 0,
          is_shared: 1,
          template_id: null,
          userArray: clientNuser.flat(2),
          certificate_image_id: this.chooseImage.certificate_image_id
        }
        const data = await saveGenerateApi(payload, this.customer_id)
        this.generateCertificatePopup = false
        this.$vs.notify({
          title: 'Success',
          text: 'Certificate generated successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 2000
        })
        this.$router
          .replace({ path: '/pages/certificate-listing' })
          .catch(() => {})
      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: 'All fields are mandatory',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 2000
        })
      }
    },
    async fetchRepo () {
      const data = await fetchRepoIdByCustomer(this.customer_id)
      this.repository_id = data.data.data.repository_id
    },
    async fetchbackgroundimg () {
      const data = await fetchbackgroundimgApi(this.customer_id)
      this.certificateImage = data.data.data.certficate_image_list
    },
    deletedIndex (deleteIndex) {
      this.files.splice(deleteIndex, 1)
      this.filesInfo.splice(deleteIndex, 1)
    },
    getFileId (obj) {
      this.fetchbackgroundimg()
      if (Array.isArray(obj)) {
        this.files = [...this.files, ...obj]
      } else {
        this.files.push(obj)
      }
    },
    appendCodeToTemplate (field_code) {
      // eslint-disable-next-line no-undef
      tinymce.activeEditor.execCommand('mceInsertContent', false, field_code)
      // this.templateData.template += ` ${field_code}`
      this.$vs.notify({
        title: 'Success',
        text: 'Code added',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        time: 2000
      })
    },
    async saveCerificate () {
      try {
        const payload = {
          title: this.Certificate_title,
          description: this.certificate_description,
          content: this.content,
          type:  this.typeSpecific,
          certificate_image_id: this.chooseImage.certificate_image_id
        }
        if (this.editTrue) {
          const data = await updateTemplateCerificateApi(
            payload,
            this.customer_id,
            this.$route.params.editing_object.certificate_template_id
          )
          this.msg = 'Certificate Updated successfully'
          
        } else {
          const data = await saveCerificateApi(payload, this.customer_id)
          this.msg = 'Certificate Saved successfully'
         
        }
        this.$vs.notify({
          title: 'Success',
          text: this.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.$router
          .replace({ path: '/pages/certificate-listing' })
          .catch(() => {})
      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: 'All fields are mandatory',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }
    },
    async fetchDynamicField () {
      if (this.typeSpecific == 0) {
        this.dynamic_specific = 'general'
      } else if (this.typeSpecific == 1) {
        this.dynamic_specific = 'course_specific'
      } else {
        this.dynamic_specific = 'class_specific'
      }
      const payload = {
        type:this.dynamic_specific
      }
      const data = await dynamicFieldApi(payload)
      this.dynamic_field = data.data.data.certificate_dynamic_field
    },
    openMenubar () {
      this.demoActive = !this.demoActive
    },
    closeSelectedUser1 (index) {
      this.selectedStaffs.splice(index, 1)
    },
    closeSelectedUser2 (index) {
      this.selectedStudents.splice(index, 1)
    }
  }
}
</script>

<style>
.delTemImg_holder {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
}
.delTemImg_holder span {
  font-size: 16px;
  color: red;
}
.selected_image_holder {
  width: 100%;
  position: absolute;
  left: 0;
  top: 85px;
  padding: 0 40px;
  text-align: center;
}
.overlay_btn{
  position:relative;
  display: inline-block;
}
.overlay_btn::before{
  content: "";
  width: 100%;
  height:100%;
  background:rgba(255,255,255,0.5);
  position:absolute;
  top:0;
  left:0;
  z-index: 100;
  cursor: not-allowed;
}

</style>
